export default {
    deliver: 'Deliver',
    receive: 'Receive',
    'remaining-samples': 'Remaining Samples',
}